var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-input"},[_c('button',{staticClass:"button is-small m-0",class:[_vm.classes],attrs:{"data-id":"detail-ticket-button","disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.required)?_c('span',[_c('b',[_vm._v(_vm._s(_vm.name))])]):_c('span',[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }